import { Flex } from 'front-commons/ds/components/Flex';
import { Icon } from 'front-commons/ds/components/Icon';
import { Typography } from 'hype-ds';
import { Link } from 'react-router-dom';
import { DATA_TESTID_ALTERNATIVE_NAVIGATION_BANNER } from './constants';
import { useBannerHeight } from './hooks/useBannerHeight';
import type { AlternativeNavigationBannerProps } from './interfaces';

export function AlternativeNavigationBanner({
	title,
	icon,
	description,
	showMore = false,
}: AlternativeNavigationBannerProps) {
	const bannerRef = useBannerHeight();

	return (
		<Flex
			ref={bannerRef}
			alignItems="center"
			justifyContent="center"
			padding="0 16px"
			maxHeight="78px"
			height={{ small: '78px', medium: '37px' }}
			position="relative"
			data-testid={DATA_TESTID_ALTERNATIVE_NAVIGATION_BANNER}
			zIndex={110}
			raw={{
				backgroundColor: 'var(--greys-100)',
				"&[data-hidden='true']": { display: 'none' },
				img: { height: '20px', alignSelf: 'center' },
				'[data-component="Typography"]': { display: 'inline-block' },
				'a [data-component="Typography"]': { textDecoration: 'underline' },
			}}
		>
			<Flex
				width="100%"
				justifyContent="center"
				wrap="nowrap"
				gap={{ small: '0', medium: '8px' }}
				alignItems={{ small: 'center', medium: 'baseline' }}
				direction={{ small: 'column', medium: 'row' }}
			>
				<Flex height="100%" alignItems="baseline" gap="8px">
					<Flex height="100%" alignSelf="center">
						{icon && <Icon name={icon} color="--greys-700" fill size="20px" />}
					</Flex>
					<Typography.Label.M as="p" color="--greys-900" textAlign="center">
						{title}
					</Typography.Label.M>
				</Flex>
				<Flex wrap={{ small: 'wrap', medium: 'nowrap' }} justifyContent={{ small: 'center' }} direction="row">
					<Typography fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" color="--greys-900" textAlign="center">
						{description}{' '}
						{showMore && (
							<Link to="/perguntas-frequentes">
								<Typography.Link.M
									fontSize="0.875rem"
									lineHeight="1.25rem"
									color="--hympar-blue-700"
									textAlign="center"
								>
									Saiba mais
								</Typography.Link.M>
							</Link>
						)}
					</Typography>
				</Flex>
			</Flex>
		</Flex>
	);
}
